import { createAction, props } from '@ngrx/store';
export const setReportFooter = createAction('[Custom PDF Report Builder] Set Report Footer', props());
